import SFetch from '@app/utils/sfetch'

type toggleCheckEndpointType =
  | 'unread_ledger_assistant_checks_path'
  | 'read_ledger_assistant_checks_path'
  | 'unread_ledger_assistant_checks_v2_index_path'
  | 'read_ledger_assistant_checks_v2_index_path'

const getUrl = (type: 'read' | 'unread', checkId: string): string => {
  const v2 = window.Silverfin.currentFirmFeatures.supports_v2_checks
  const route = `${type}_ledger_assistant_checks_${
    v2 ? 'v2_index_' : ''
  }path` as toggleCheckEndpointType

  return window.Silverfin.Routes[route](
    window.Silverfin.currentFirmId,
    window.Silverfin.currentCompanyId,
    window.Silverfin.currentLedgerId(),
    checkId
  )
}

const toggleCheck = ({
  type,
  checkId,
}: {
  type: 'read' | 'unread'
  checkId: string
}): Promise<void | null> => {
  const url = getUrl(type, checkId)
  return SFetch.json(`${url}`, {
    method: 'POST',
  })
}

export { toggleCheck }
